import { RoutalPalette, RoutalSelect } from '@nx-smartmonkey/ui';
import React, { useState } from 'react';

import Text from '../../../react-components/Text';
import { ClientsFromScratchDialog } from './ClientsFromScratchDialog';
import { DataImporter } from './clients-data-importer';

type ClientsCreateMenuProps = {
  id: string;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  hideSeparator?: boolean;
  disabled?: boolean;
  intlId?: string;
  intlValues?: Record<string, string | number | ((chunks: any) => React.ReactElement)>;
};

const ClientsCreateMenu = ({
  id,
  style,
  containerStyle,
  hideSeparator,
  disabled,
  intlId,
  intlValues,
}: ClientsCreateMenuProps) => {
  const [dialog, setDialog] = useState<`clientsFromScratch` | `clientsFromFile` | undefined>(undefined);

  return (
    <>
      <RoutalSelect
        id={id}
        style={style}
        hideSeparator={hideSeparator}
        containerStyle={containerStyle}
        arrowStyle={{
          color: RoutalPalette.oldWhite,
        }}
        disabled={disabled}
        popoverProps={{
          options: [
            {
              key: `from_scratch`,
              onClick: () => setDialog(`clientsFromScratch`),
              content: <Text intlId="plans.create_client_from_scratch" style={{ cursor: `pointer` }} />,
            },
            {
              key: `upload_excel`,
              onClick: () => setDialog(`clientsFromFile`),
              content: <Text intlId="plans.upload_excel" style={{ cursor: `pointer` }} />,
            },
          ],
        }}
      >
        <Text
          intlId={intlId ?? `clients.new`}
          intlValues={intlValues}
          style={{ color: RoutalPalette.oldWhite, cursor: `pointer` }}
        />
      </RoutalSelect>

      <ClientsFromScratchDialog
        open={Boolean(dialog === `clientsFromScratch`)}
        handleCloseDialog={(e: any) => {
          e.stopPropagation();
          setDialog(undefined);
        }}
      />

      <DataImporter
        open={Boolean(dialog === `clientsFromFile`)}
        handleCloseDialog={(e: any) => {
          if (e) e.stopPropagation();
          setDialog(undefined);
        }}
        onComplete={() => {
          setDialog(undefined);
        }}
      />
    </>
  );
};

export default ClientsCreateMenu;
